export default __webpack_public_path__ + "static/media/magic-stick.4b3ee391.svg";